import { PlusCircleIcon } from "@heroicons/react/24/outline";
import React, { useContext, useEffect, useState } from "react";
import image1 from "../../../assets/frontendassets/breadcrumb.jpg";
import { AutoComplete, Button, Checkbox, Col, Dropdown, Form, Input, Menu, message, Progress, Radio, Row, Select, Spin, Steps, TimePicker, Upload, Space } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { RxCross2 } from "react-icons/rx";
import "./Listing.css";
import "react-quill/dist/quill.snow.css";
import Dragger from "antd/es/upload/Dragger";
import { BiSolidInbox, BiUser } from "react-icons/bi";
import { CloseOutlined } from "@ant-design/icons";
import img1 from "../../../../assets/frontendassets/businessFormSteps/6.png";
import img2 from "../../../../assets/frontendassets/businessFormSteps/2.png";
import img3 from "../../../../assets/frontendassets/businessFormSteps/3.png";
import img4 from "../../../../assets/frontendassets/businessFormSteps/5.png";
import "./AddListing.css";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { addBusiness, getAllcategories, validateBusinessApi } from "../../../../utils/API";
import axios from "axios";
import { AuthContext } from "../../../Auth/AuthContext";
import countriesData from "../../../../utils/countries.json";
import { detectCountryCodeForBusiness } from "../../../../utils/setting";
import { detectCountryCode } from "../../../../utils/setting";
import countryData from "./country.json"
import PhoneInput from "react-phone-input-2";

interface City {
  id: number;
  name: string;
  latitude: string;
  longitude: string;
}

interface State {
  id: number;
  name: string;
  state_code: string;
  latitude: string;
  longitude: string;
  country_id: number;
  cities: City[];
}
const statesData: State[] = require("../../../../utils/states+cities.json");

const { Option } = Select;
const { Step } = Steps;

interface Day {
  name: string;
  selected: boolean;
  openTime: string;
  closeTime: string;
}

interface Business {
  name: string;
  hours: Day[];
}


interface Category {
  _id: string;
  name: string;
  categoryId: string | null;
  category_image: string;
  isHome: boolean;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const times = Array.from({ length: 24 }, (_, i) => [
  `${i < 10 ? '0' : ''}${i}:00`,
  `${i < 10 ? '0' : ''}${i}:30`
]).flat();

const countryMobileLengths: { [key: string]: number } = {
  AD: 6,  // Andorra
  AE: 9,  // United Arab Emirates
  AF: 9,  // Afghanistan
  AG: 10, // Antigua and Barbuda
  AI: 10, // Anguilla
  AL: 9,  // Albania
  AM: 8,  // Armenia
  AO: 9,  // Angola
  AR: 10, // Argentina
  AS: 10, // American Samoa
  AT: 10, // Austria
  AU: 9,  // Australia
  AW: 7,  // Aruba
  AX: 10, // Åland Islands
  AZ: 9,  // Azerbaijan
  BA: 8,  // Bosnia and Herzegovina
  BB: 10, // Barbados
  BD: 10, // Bangladesh
  BE: 9,  // Belgium
  BF: 8,  // Burkina Faso
  BG: 8,  // Bulgaria
  BH: 8,  // Bahrain
  BI: 8,  // Burundi
  BJ: 8,  // Benin
  BL: 6,  // Saint Barthélemy
  BM: 10, // Bermuda
  BN: 7,  // Brunei
  BO: 8,  // Bolivia
  BQ: 7,  // Bonaire
  BR: 11, // Brazil
  BS: 10, // Bahamas
  BT: 8,  // Bhutan
  BW: 8,  // Botswana
  BY: 9,  // Belarus
  BZ: 7,  // Belize
  CA: 10, // Canada
  CC: 6,  // Cocos (Keeling) Islands
  CD: 9,  // Democratic Republic of the Congo
  CF: 8,  // Central African Republic
  CG: 9,  // Republic of the Congo
  CH: 9,  // Switzerland
  CI: 8,  // Côte d'Ivoire
  CK: 5,  // Cook Islands
  CL: 9,  // Chile
  CM: 9,  // Cameroon
  CN: 11, // China
  CO: 10, // Colombia
  CR: 8,  // Costa Rica
  CU: 8,  // Cuba
  CV: 7,  // Cape Verde
  CW: 7,  // Curaçao
  CX: 6,  // Christmas Island
  CY: 8,  // Cyprus
  CZ: 9,  // Czech Republic
  DE: 10, // Germany
  DJ: 8,  // Djibouti
  DK: 8,  // Denmark
  DM: 10, // Dominica
  DO: 10, // Dominican Republic
  DZ: 9,  // Algeria
  EC: 9,  // Ecuador
  EE: 7,  // Estonia
  EG: 10, // Egypt
  EH: 9,  // Western Sahara
  ER: 7,  // Eritrea
  ES: 9,  // Spain
  ET: 9,  // Ethiopia
  FI: 10, // Finland
  FJ: 7,  // Fiji
  FM: 7,  // Micronesia
  FO: 6,  // Faroe Islands
  FR: 9,  // France
  GA: 7,  // Gabon
  GB: 10, // United Kingdom
  GD: 10, // Grenada
  GE: 9,  // Georgia
  GF: 9,  // French Guiana
  GG: 10, // Guernsey
  GH: 9,  // Ghana
  GI: 8,  // Gibraltar
  GL: 6,  // Greenland
  GM: 7,  // Gambia
  GN: 9,  // Guinea
  GP: 9,  // Guadeloupe
  GQ: 9,  // Equatorial Guinea
  GR: 10, // Greece
  GT: 8,  // Guatemala
  GU: 10, // Guam
  GW: 7,  // Guinea-Bissau
  GY: 7,  // Guyana
  HK: 8,  // Hong Kong
  HN: 8,  // Honduras
  HR: 9,  // Croatia
  HT: 8,  // Haiti
  HU: 9,  // Hungary
  ID: 10, // Indonesia
  IE: 9,  // Ireland
  IL: 9,  // Israel
  IM: 10, // Isle of Man
  IN: 10, // India
  IO: 7,  // British Indian Ocean Territory
  IQ: 10, // Iraq
  IR: 10, // Iran
  IS: 7,  // Iceland
  IT: 10, // Italy
  JE: 10, // Jersey
  JM: 10, // Jamaica
  JO: 9,  // Jordan
  JP: 10, // Japan
  KE: 9,  // Kenya
  KG: 9,  // Kyrgyzstan
  KH: 9,  // Cambodia
  KI: 5,  // Kiribati
  KM: 7,  // Comoros
  KN: 10, // Saint Kitts and Nevis
  KP: 10, // North Korea
  KR: 10, // South Korea
  KW: 8,  // Kuwait
  KY: 10, // Cayman Islands
  KZ: 10, // Kazakhstan
  LA: 9,  // Laos
  LB: 7,  // Lebanon
  LC: 10, // Saint Lucia
  LI: 9,  // Liechtenstein
  LK: 7,  // Sri Lanka
  LR: 7,  // Liberia
  LS: 8,  // Lesotho
  LT: 8,  // Lithuania
  LU: 9,  // Luxembourg
  LV: 8,  // Latvia
  LY: 9,  // Libya
  MA: 9,  // Morocco
  MC: 8,  // Monaco
  MD: 8,  // Moldova
  ME: 8,  // Montenegro
  MF: 6,  // Saint Martin
  MG: 9,  // Madagascar
  MH: 7,  // Marshall Islands
  MK: 8,  // North Macedonia
  ML: 8,  // Mali
  MM: 9,  // Myanmar
  MN: 8,  // Mongolia
  MO: 8,  // Macau
  MP: 10, // Northern Mariana Islands
  MR: 8,  // Mauritania
  MS: 10, // Montserrat
  MT: 8,  // Malta
  MU: 8,  // Mauritius
  MV: 7,  // Maldives
  MW: 9,  // Malawi
  MX: 10, // Mexico
  MY: 9,  // Malaysia
  MZ: 9,  // Mozambique
  NA: 8,  // Namibia
  NC: 6,  // New Caledonia
  NE: 8,  // Niger
  NF: 6,  // Norfolk Island
  NG: 10, // Nigeria
  NI: 8,  // Nicaragua
  NL: 9,  // Netherlands
  NO: 8,  // Norway
  NP: 10, // Nepal
  NR: 7,  // Nauru
  NU: 4,  // Niue
  NZ: 9,  // New Zealand
  OM: 8,  // Oman
  PA: 8,  // Panama
  PE: 9,  // Peru
  PF: 6,  // French Polynesia
  PG: 7,  // Papua New Guinea
  PH: 10, // Philippines
  PK: 10, // Pakistan
  PL: 9,  // Poland
  PM: 6,  // Saint Pierre and Miquelon
  PN: 6,  // Pitcairn Islands
  PR: 10, // Puerto Rico
  PT: 9,  // Portugal
  PW: 7,  // Palau
  PY: 9,  // Paraguay
  QA: 8,  // Qatar
  RE: 9,  // Réunion
  RO: 10, // Romania
  RS: 9,  // Serbia
  RU: 10, // Russia
  RW: 9,  // Rwanda
  SA: 9,  // Saudi Arabia
  SB: 7,  // Solomon Islands
  SC: 7,  // Seychelles
  SD: 9,  // Sudan
  SE: 9,  // Sweden
  SG: 8,  // Singapore
  SH: 6,  // Saint Helena
  SI: 8,  // Slovenia
  SK: 9,  // Slovakia
  SL: 8,  // Sierra Leone
  SM: 10, // San Marino
  SN: 9,  // Senegal
  SO: 8,  // Somalia
  SR: 7,  // Suriname
  SS: 9,  // South Sudan
  ST: 7,  // São Tomé and Príncipe
  SV: 8,  // El Salvador
  SX: 7,  // Sint Maarten
  SY: 9,  // Syria
  SZ: 8,  // Eswatini
  TC: 10, // Turks and Caicos Islands
  TD: 8,  // Chad
  TG: 8,  // Togo
  TH: 9,  // Thailand
  TJ: 9,  // Tajikistan
  TK: 4,  // Tokelau
  TL: 7,  // Timor-Leste
  TM: 8,  // Turkmenistan
  TN: 8,  // Tunisia
  TO: 5,  // Tonga
  TR: 10, // Turkey
  TT: 10, // Trinidad and Tobago
  TV: 6,  // Tuvalu
  TW: 10, // Taiwan
  TZ: 9,  // Tanzania
  UA: 9,  // Ukraine
  UG: 9,  // Uganda
  US: 10, // United States
  UY: 8,  // Uruguay
  UZ: 9,  // Uzbekistan
  VA: 10, // Vatican City
  VC: 10, // Saint Vincent and the Grenadines
  VE: 10, // Venezuela
  VG: 10, // British Virgin Islands
  VI: 10, // U.S. Virgin Islands
  VN: 9,  // Vietnam
  VU: 7,  // Vanuatu
  WF: 6,  // Wallis and Futuna
  WS: 7,  // Samoa
  YE: 9,  // Yemen
  YT: 9,  // Mayotte
  ZA: 9,  // South Africa
  ZM: 9,  // Zambia
  ZW: 9   // Zimbabwe
};

const AddListing = () => {
  const logo = require("../../../../assets/backendassets/logo.png");
  const [form] = Form.useForm();
  const [isValidating, setIsValidating] = useState(false);
  const [businessName, setBusinessName] = useState('');
  const [categoryId, setCategoryId] = useState('');
  const [subcategoryId, setSubcategoryId] = useState([]);
  const [gstinNo, setGstinNo] = useState('');
  const [pincode, setPincode] = useState('');
  const [buildingName, setbuildingName] = useState('');
  const [streetName, setStreetName] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [country, setCountry] = useState('');
  const [contactPersonName, setContactPersonName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [landlineNumber, setLandlineNumber] = useState('');
  const [email, setEmail] = useState('');
  const [current, setCurrent] = useState(0);
  const [subdomain, setSubdomain] = useState('');
  // const isRapidexieLogin = localStorage.getItem("isRapidexieLogin") 
  // console.log("isRapidexieLogin", isRapidexieLogin);
  const [businessData, setbusinessData] = useState([]);
  const [galleryFileList, setGalleryFileList] = useState<any>([]);
  const [galleryPreviewImages, setGalleryPreviewImages] = useState<any[]>([]);
  const { authData } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const customerId = authData.user._id;
  const userId = customerId.replace(/"/g, '');
  const [categoryData, setCategoryData] = useState<Category[]>([]);
  const [subCategories, setSubCategories] = useState<Category[]>([]);
  const [pinloading, setPinLoading] = useState(false);
  const [isRapidexieLogin, setIsRapidexieLogin] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState<any | null>(null);
  const [selectedState, setSelectedState] = useState<string | null>(null);
  const [cities, setCities] = useState<any>([]);
  const [selectedCity, setSelectedCity] = useState<string | null>(null);
  const [states, setStates] = useState<{ code: string; country: string }[]>([]);
  const [countryCode, setCountryCode] = useState("IN");
  // const [mobile, setMobile] = useState("");
  const [minMobileLength, setMinMobileLength] = useState(10);
  const [minWhatsappLength, setMinWhatsappLength] = useState(10);
  const [minPhoneLength, setMinPhoneLength] = useState(10);
  const [selectedMobileCountry, setSelectedMobileCountry] = useState<any | null>(null);
  const [selectedWhatsappCountry, setSelectedWhatsappCountry] = useState<any | null>(null);
  const [selectedPhoneCountry, setSelectedPhoneCountry] = useState<any | null>(null);





  useEffect(() => {
    const loginState = localStorage.getItem("isRapidexieLogin") === "true"; // Check if user is logged in
    setIsRapidexieLogin(loginState); // Update state based on login status
  }, []); // Empty array ensures it runs only on mount
  const navigate = useNavigate();
  const [days, setDays] = useState<Day[]>([
    { name: 'Mon', selected: false, openTime: '', closeTime: '' },
    { name: 'Tue', selected: false, openTime: '', closeTime: '' },
    { name: 'Wed', selected: false, openTime: '', closeTime: '' },
    { name: 'Thu', selected: false, openTime: '', closeTime: '' },
    { name: 'Fri', selected: false, openTime: '', closeTime: '' },
    { name: 'Sat', selected: false, openTime: '', closeTime: '' },
    { name: 'Sun', selected: false, openTime: '', closeTime: '' },
  ]);
  const [selectAll, setSelectAll] = useState(false);
  const [contactvalue, setcontactValue] = useState('');

  useEffect(() => {
    const fetchCountryCode = async () => {
      const detectedDialingCode = await detectCountryCode(); // e.g., '+31'
      console.log("detectedDialingCode", detectedDialingCode);

      const countryCodeMap: { [key: string]: string } = countryData.reduce((map: any, country: any) => {
        map[country.dialCode] = country.code.toLowerCase();
        return map;
      }, {});

      const detectedCountryCode = countryCodeMap[detectedDialingCode] || "in"; // Default to India
      console.log("Detected Country Code:", detectedCountryCode);

      setCountryCode(detectedCountryCode);
    };

    fetchCountryCode();
  }, []);

  // const handlePhoneChange = (value: string, country: any, type: any) => {
  //   // setMobile(value);
  //   console.log("country", country);
  //   if(type == "mobile"){
  //     setMobileNumber(value);
  //   }else if(type == "phone"){
  //     setLandlineNumber(value);
  //   }else if(type == "whatsapp"){
  //     setWhatsappNumber(value);
  //   }
  //   const selectedCountryCode = country.countryCode.toUpperCase();
  //   console.log("selectedCountryCode", selectedCountryCode);

  //   // setCountryCode(selectedCountryCode);
  //   // setMinMobileLength(countryMobileLengths[selectedCountryCode] || 9);
  // };

  const handlePhoneChange = (value: string, country: any) => {
    setMobileNumber(value);
    setSelectedMobileCountry(country);
    const selectedCountryCode = country.countryCode.toUpperCase();
    setCountryCode(selectedCountryCode);
    const dialCode = country.dialCode; // Assuming country.dialCode is 36
    const length = dialCode.toString().length;
    setMinMobileLength(countryMobileLengths[selectedCountryCode] + length || 9);
  };

  const handleWhatsappChange = (value: string, country: any) => {
    setWhatsappNumber(value);
    setSelectedWhatsappCountry(country);
    const selectedCountryCode = country.countryCode.toUpperCase();
    setCountryCode(selectedCountryCode);
    const dialCode = country.dialCode; // Assuming country.dialCode is 36
    const length = dialCode.toString().length;
    setMinWhatsappLength(countryMobileLengths[selectedCountryCode] + length || 9);
  };

  const handleLandlineChange = (value: string, country: any) => {
    setLandlineNumber(value);
    setSelectedPhoneCountry(country);
  };

  const handleCountryChange = (value: string) => {
    // const selected = e.target.value;
    setSelectedCountry(value);
    setCountry(value);
    setCities([]);
    setStates([]);
    setSelectedState(null); // Reset state when country changes
    setSelectedCity(null); // Reset state when country changes

    const country = countriesData.countries.find((c) => c.country === value);
    setStates(country ? country.states : []);
  };
  const handleStateChange = (value: string) => {
    // const selected = e.target.value;
    setSelectedState(value); // Reset state when country changes
    setState(value);
    setCities([]);
    setSelectedCity(null);

    const state = statesData.find((state) => state.name == value)
    console.log("state.cities", state);
    if (state) {
      if (state.cities.length > 0) {
        setCities(state.cities);
        setSelectedCity(state.cities[0]?.name);
        setCity(state.cities[0]?.name);
      }
    }
  };

  const onChange = (data: any) => {
    setcontactValue(data);
  };

  const handleDayChange = (index: number, field: string, value: boolean | string) => {
    const newDays = [...days];
    if (field === 'selected') {
      newDays[index].selected = value as boolean;
    } else if (field === 'openTime' || field === 'closeTime') {
      newDays[index][field] = value as string;
      if (field === 'openTime' && newDays[index].closeTime && newDays[index].closeTime < value) {
        newDays[index].closeTime = value as string;
      }
    }
    setDays(newDays);

  };

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);

    // Update the `days` array to select or deselect all days
    setDays(days.map(day => ({ ...day, selected: newSelectAll })));

    if (newSelectAll) {
      setDays(days.map(day => ({ ...day, selected: true })));
    } else {
      setDays(days.map(day => ({ ...day, selected: false })));
    }

  };
  const handlePincodeChange = async (e: any) => {
    const pincode = e.target.value;
    setPincode(pincode);
    const API_KEY = process.env.REACT_APP_PINCODE_KEY;

    if (pincode.length > 2) {
      setPinLoading(true);
      try {
        // const response = await axios.get(
        //   `https://pincode.apitier.com/v1/in/places/pincode?x-api-key=${API_KEY}&pincode=${pincode}`
        // );

        // const pincodeData = response.data.result; // Check response structure in console
        // console.log("pincodeData:", pincodeData);

        // if (pincodeData && pincodeData.length > 0) {
        //   const firstLocation = pincodeData[0]; // Fix: Directly accessing array
        //   setCity(firstLocation.placename);
        //   setState(firstLocation.statename);
        //   form.setFieldsValue({
        //     city: firstLocation.placename,
        //     state: firstLocation.statename,
        //   });
        // } else {
        //   form.setFieldsValue({
        //     city: '',
        //     state: '',
        //   });
        //   message.error("No data found for the entered pincode");
        // }

      } catch (error) {
        message.error("Failed to fetch pincode data");
      } finally {
        setPinLoading(false);
      }
    }
  };

  const handlePincodeBlure = async () => {
    if (pincode.length > 2) {
      setPinLoading(true);
      setCities([]);
      setStates([]);
      setSelectedState(null);
      setSelectedCity(null);
      setSelectedCountry(null);

      try {
        const data: any = await detectCountryCodeForBusiness(pincode);
        const country = countriesData.countries.find((c) => c.country === data.country);
        if (country) {
          setSelectedCountry(country.country);
          setCountry(country.country);
          setStates(country.states); // Set available states
          if (country.states.length > 0 && data.state) {
            const state = statesData.find((s) => s.name === data.state);
            if (state) {
              setSelectedState(state.name);
              setState(state.name);

              if (state.cities.length > 0) {
                setCities(state.cities);
                const city = state.cities.find((c) => c.name === data.city);
                setSelectedCity(city?.name || state.cities[0]?.name);
                setCity(city?.name || state.cities[0]?.name);
              }
            }
          }
        }

      } catch (error) {
        message.error("Failed to fetch pincode data");
      } finally {
        setPinLoading(false);
      }
    }
  }

  const handleCategoryChange = (value: string) => {
    setCategoryId(value);
    form.setFieldsValue({ subcategoryId: [] });

    const filteredSubCategories = categoryData.filter(category => category.categoryId === value);
    setSubCategories(filteredSubCategories);
  };


  useEffect(() => {
    if (businessName && categoryId) {
      validateBusiness(businessName, categoryId);
    }
  }, [businessName, categoryId]);

  const fetchCategories = async () => {
    try {
      const response = await getAllcategories();
      setCategoryData(response);
    } catch (error) {
      message.error("Network error. Please try again.");
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // const next = () => {
  //   if (current === 2) {
  //     const isAnyDaySelected = days.some(day => day.selected);
  //     if (!isAnyDaySelected) {
  //       message.error('Please select at least one opening day before proceeding.');
  //       return;
  //     }
  //   }  
  //   form.validateFields()
  //     .then(values => {
  //       console.log("Validated values:", values); // Debugging
  //       setbusinessData(prevData => ({ ...prevData, ...values }));
  //       setCurrent(prev => prev + 1);
  //     })
  //     .catch(errorInfo => {
  //       console.log("Form validation errors:", errorInfo);
  //       message.error('Please fill in all required fields');
  //     });
  // };


  useEffect(() => {
    // Ensure the first step is added to history
    if (!window.history.state || window.history.state.step === undefined) {
      window.history.replaceState({ step: 0 }, "", "#step-0");
    }

    const handlePopState = (event : any) => {
      if (event.state && event.state.step !== undefined) {
        setCurrent(event.state.step);
      } else {
        // If state is undefined, ensure it stays on step 0
        setCurrent(0);
        window.history.replaceState({ step: 0 }, "", "#step-0");
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);


  const updateStep = (step : any) => {
    setCurrent(step);
    window.history.pushState({ step }, "", `#step-${step}`); // Update URL without full page reload
  };


  const next = () => {
    if (current === 2) {
      const isAnyDaySelected = days.some(day => day.selected);
      if (!isAnyDaySelected) {
        message.error('Please select at least one opening day before proceeding.');
        return;
      }
    }


    // Manually validating required fields
    if (!businessName.trim()) {
      message.error('Please input your Business Name!');
      return;
    }
    if (!categoryId) {
      message.error('Please Choose a Category of your Business!');
      return;
    }
    if (!subcategoryId.length) {
      message.error('Please Choose a Subcategory of your Business!');
      return;
    }
    // if (!pincode.match(/^[1-9][0-9]{5}$/)) {
    //   message.error('Please enter a valid Pincode!');
    //   return;
    // }
    if (!buildingName.trim()) {
      message.error('Please input your Building Name!');
      return;
    }
    if (!streetName.trim()) {
      message.error('Please input your Street Name!');
      return;
    }
    if (!city.trim()) {
      message.error('Please input your City!');
      return;
    }
    if (!state.trim()) {
      message.error('Please input your State!');
      return;
    }

    if (current === 1) {
      if (!contactPersonName.trim()) {
        message.error('Please input Contact Person Name!');
        return;
      }
      const mobileLength = selectedMobileCountry?.dialCode?.length || 0; // Assuming country.dialCode is 36
      const whatsappLength = selectedWhatsappCountry?.dialCode?.length || 0; // Assuming country.dialCode is 36
      const phoneLength = selectedPhoneCountry?.dialCode?.length || 0; // Assuming country.dialCode is 36
      // const length = dialCode.toString().length;

      const nationalNumber = mobileNumber.startsWith("+")
        ? mobileNumber.substring(selectedMobileCountry?.dialCode?.length + 1)
        : mobileNumber;
      if (!nationalNumber || nationalNumber.length < (minMobileLength)) {
        message.error(`Please enter a valid mobile number (${(minMobileLength - mobileLength)} digits required)`);
        return;
      }

      // if (!mobileNumber.match(/^\d{10}$/)) {
      //   message.error('Please enter a valid 10-digit Mobile Number!');
      //   return;
      // }

      const nationalWhatsappNumber = whatsappNumber.startsWith("+") ? whatsappNumber.substring(selectedWhatsappCountry?.dialCode?.length + 1) : whatsappNumber;

      if (!nationalWhatsappNumber || nationalWhatsappNumber.length < (minWhatsappLength)) {
        message.error(`Please enter a valid Whatsapp number (${(minWhatsappLength - whatsappLength)} digits required)`);
        return;
      }

      // if (!whatsappNumber.match(/^\d{10}$/)) {
      //   message.error('Please enter a valid 10-digit WhatsApp Number!');
      //   return;
      // }
    }

    // Updating business data
    setbusinessData(prevData => ({
      ...prevData,
      businessName,
      categoryId,
      subcategoryId,
      gstinNo,
      pincode,
      buildingName,
      streetName,
      city,
      contactPersonName,
      mobileNumber,
      whatsappNumber,
      landlineNumber,
      email,
      state,
      country
    }));

    console.log("businessData of First Step:", businessData);
    setCurrent((prev) => {
      const nextStep = prev + 1;
      updateStep(nextStep);
      return nextStep;
    });
  };



  const prev = () => {
    setCurrent(current - 1);
    if (current > 0) {
      updateStep(current - 1);
    }
  };

  const getBase64 = (file: any) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const galleryImageProps = {
    name: "galleryImage",
    multiple: true,
    beforeUpload(file: any) {
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        message.error("You can only upload image files!");
        return Upload.LIST_IGNORE; // Prevents non-images from being added
      }
      const isLt10M = file.size / 1024 / 1024 < 10; // Restrict to 10MB
      if (!isLt10M) {
        message.error("Image must be smaller than 10MB!");
        return Upload.LIST_IGNORE;
      }
      return isImage && isLt10M;
    },
    onChange(info: any) {
      const validFiles = info.fileList.filter((file: any) => file.type.startsWith("image/") && file.size / 1024 / 1024 < 10);
      setGalleryFileList(validFiles);

      const newGalleryPreviewImages = validFiles.map(async (file: any) => {
        if (!file.url && !file.preview) {
          file.preview = await getBase64(file.originFileObj);
        }
        return file.url || file.preview;
      });

      Promise.all(newGalleryPreviewImages).then((images) => {
        setGalleryPreviewImages(images);
      });
    },
    fileList: galleryFileList,
  };

  const handleRemoveGalleryImage = (index: number) => {
    const newGalleryFileList = [...galleryFileList];
    newGalleryFileList.splice(index, 1);
    setGalleryFileList(newGalleryFileList);

    const newGalleryPreviewImages = [...galleryPreviewImages];
    newGalleryPreviewImages.splice(index, 1);
    setGalleryPreviewImages(newGalleryPreviewImages);
  };

  const validateBusiness = async (business: string, category: string) => {
    if (!business.trim() || !category) return; // Ensure both values exist

    const combinedData = { businessName: business.trim(), categoryId: category };

    try {
      const response = await validateBusinessApi(combinedData);
      console.log(response);
      if (!response.isUnique) {
        message.error("A business with the same name and category already exists!");
      }
    } catch (error: any) {
      message.error(error.message || "Validation failed. Try again later.");
      return Promise.reject(new Error(error.message || "Validation failed. Try again later."));
    }
  };
  const onFinish = (values: any) => {
    const combinedData = { ...values, ...businessData };

    const formData = new FormData();

    Object.keys(combinedData).forEach((key: any) => {
      if (key !== 'galleryImage') {
        formData.append(key, combinedData[key]);
      }
    });

    // Handle gallery images stored in values
    if (galleryFileList && galleryFileList.length > 0) {
      galleryFileList.forEach((file: any, index: any) => {
        formData.append(`galleryImage`, galleryFileList[index].originFileObj as Blob);
      });
    }

    const allDays = days.map(day => ({
      ...day,
      openTime: day.selected ? day.openTime : '',
      closeTime: day.selected ? day.closeTime : ''
    }));
    formData.append("businessHours", JSON.stringify(allDays));
    formData.append("userId", userId);

    setLoading(true); // Set loading to true when form submission starts
    addBusiness(formData)
      .then((response: any) => {
        message.success(response.data.message);

        // Pass data to the success page
        const successData = {
          message: response.data.message,
          businessDetails: combinedData,
          businessHours: allDays,
        };
        navigate("/business/success", { state: successData });
      })
      .catch((error: any) => {
        console.error('API Error:', error);
      })
      .finally(() => {
        setLoading(false); // Set loading to false after form submission is complete or fails
      });
  };

  const onFinishForm = () => {
    if (isValidating || galleryFileList.some((file: any) => file.size / 1024 / 1024 >= 10)) return; // Prevent submission if any file exceeds 10MB


    form.validateFields()
      .then(values => {
        setIsValidating(true); // Set to true during validation

        const usertype = authData.user.usertype;
        const valuesWithUsertype = { ...values, usertype };
        onFinish(valuesWithUsertype);
      })
      .catch(errorInfo => {
        message.error('Please fill in all required fields');
      })
      .finally(() => setIsValidating(false)); // Reset after validation
  };


  const steps = [
    {
      title: "General Information",
      imgSrc: img1,
      content: (
        <>
          <Row className="mt-8">
            <Col span={24}>

              {/* <label className="  mt-4 ml-1 mb-1">
                Business Name
                <span className="text-red-500">*</span>
              </label> */}
              <Form.Item
                name="businessName"
                className="mb-4"
              >
                <label
                  htmlFor="name"
                  className="absolute -top-4 z-1 left-6 bg-white px-2 text-[18px] text-black"
                >
                  Business Name  <span className="text-[#F9B138]"><span className="text-[#F9B138]">*</span></span>
                </label>
                <Input
                  value={businessName}
                  onChange={(e) => setBusinessName(e.target.value)}
                  placeholder="Enter Business Name"
                  size="large"
                  className="Allinput"
                />
              </Form.Item>
              <div>
                <Form.Item name="categoryId" className="mb-4">
                  <label
                    htmlFor="categoryId"
                    className="absolute -top-4 z-1 left-6 bg-white px-2 text-[18px] text-black"
                  >
                    Category <span className="text-[#F9B138]">*</span>
                  </label>
                  <Select
                    placeholder="Select Category"
                    size="large"
                    allowClear
                    showSearch
                    onChange={handleCategoryChange}
                    value={categoryId || undefined} // Ensures placeholder appears when no value is selected
                    filterOption={(input: any, option: any) =>
                      option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {categoryData
                      .filter(
                        (category) =>
                          (!category.categoryId || category.categoryId === 'null') &&
                          category.isDeleted === false
                      )
                      .map((category) => (
                        <Select.Option key={category._id} value={category._id}>
                          {category.name}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
              </div>

              <div>
                {/* <label className="  ml-1 mb-2">Sub Category        <span className="text-red-500">*</span></label> */}
                <Form.Item
                  className="mb-4"
                  name="subcategoryId"

                >
                  <label
                    htmlFor="name"
                    className="absolute -top-4 z-1 left-6 bg-white px-2 text-[18px] text-black"
                  >
                    SubCategory  <span className="text-[#F9B138]"><span className="text-[#F9B138]">*</span></span>
                  </label>
                  <Select
                    mode="multiple"
                    size="large"
                    value={subcategoryId}
                    onChange={(value) => setSubcategoryId(value)}
                    allowClear
                    placeholder="Select sub category"
                    removeIcon={<RxCross2 size={20} className="text-yellow-500" />}
                  >
                    {
                      subCategories.map((subCategory) => (
                        <Option key={subCategory._id} value={subCategory._id}>
                          {subCategory.name}
                        </Option>
                      ))
                    }
                  </Select>
                </Form.Item>
              </div>
              <div>
                {/* <label className="  ml-1 mb-1">PinCode        <span className="text-red-500">*</span></label> */}
                <Form.Item
                  name="pincode"
                  className="mb-4"

                >
                  <label
                    htmlFor="name"
                    className="absolute -top-4 z-1 left-6 bg-white px-2 text-[18px] text-black"
                  >
                    Pincode  <span className="text-[#F9B138]"><span className="text-[#F9B138]">*</span></span>
                  </label>
                  <Input
                    type="text"
                    placeholder="Enter PinCode"
                    size="large"
                    className="Allinput"
                    onChange={handlePincodeChange}
                    onBlur={handlePincodeBlure}
                    value={pincode}
                  />
                </Form.Item>
              </div>
              <div>
                {/* <label className="  ml-1 mb-1">GSTIN</label> */}
                <Form.Item
                  name="gstno"
                  className="mb-4"
                >
                  <label
                    htmlFor="name"
                    className="absolute -top-4 z-1 left-6 bg-white px-2 text-[18px] text-black"
                  >
                    GST NO
                  </label>
                  <Input

                    type="text"
                    placeholder="Enter GST No."
                    size="large"
                    className="Allinput"
                    value={gstinNo}
                    onChange={(e) => setGstinNo(e.target.value)}
                  />
                </Form.Item>
              </div>
              <div>
                {/* <label className="  ml-1 mb-1">
                  Block No / Building Name        <span className="text-red-500">*</span>
                </label> */}
                <Form.Item
                  name="buildingName"
                  className="mb-4"

                >
                  <label
                    htmlFor="name"
                    className="absolute -top-4 z-1 left-6 bg-white px-2 text-[18px] text-black"
                  >
                    Building Name  <span className="text-[#F9B138]"><span className="text-[#F9B138]">*</span></span>
                  </label>
                  <Input
                    placeholder="Enter Building Name"
                    size="large"
                    className="Allinput"
                    value={buildingName}
                    onChange={(e) => setbuildingName(e.target.value)}
                  />
                </Form.Item>
              </div>
              <div>
                {/* <label className="  ml-1 mb-1">
                  Street / Colony Name    
                      <span className="text-red-500">*</span>
                </label> */}
                <Form.Item
                  name="streetName"

                >
                  <label
                    htmlFor="name"
                    className="absolute -top-4 z-1 left-6 bg-white px-2 text-[18px] text-black"
                  >
                    Street Name  <span className="text-[#F9B138]"><span className="text-[#F9B138]">*</span></span>
                  </label>
                  <Input
                    placeholder="Enter Colony / Street Name"
                    size="large"
                    className="Allinput"
                    value={streetName}
                    onChange={(e) => setStreetName(e.target.value)}
                  />
                </Form.Item>
              </div>


              <div>
                {/* <label className="  ml-1 ">State        <span className="text-red-500">*</span></label> */}
                <Form.Item
                  name="state"
                >
                  <label
                    htmlFor="name"
                    className="absolute -top-4 z-1 left-6 bg-white px-2 text-[18px] text-black"
                  >
                    Country  <span className="text-[#F9B138]"><span className="text-[#F9B138]">*</span></span>
                  </label>
                  {/* <Input
                    placeholder="Country"
                    size="large"
                    className="Allinput"

                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                  /> */}
                  <Select
                    placeholder="Select Country"
                    size="large"
                    allowClear
                    showSearch
                    onChange={handleCountryChange}
                    value={selectedCountry || undefined} // Ensures placeholder appears when no value is selected
                    filterOption={(input: any, option: any) =>
                      option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {countriesData.countries.map((country) => (
                      <Select.Option key={country.code} value={country.country}>
                        {country.country}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>

              <div>
                {/* <label className="  ml-1 ">State        <span className="text-red-500">*</span></label> */}
                <Form.Item
                  name="state">
                  <label
                    htmlFor="name"
                    className="absolute -top-4 z-1 left-6 bg-white px-2 text-[18px] text-black"
                  >
                    State  <span className="text-[#F9B138]"><span className="text-[#F9B138]">*</span></span>
                  </label>
                  {/* <Input
                    placeholder="State"
                    size="large"
                    className="Allinput"
                    disabled={pinloading}
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                  /> */}
                  <Select
                    placeholder="Select State"
                    size="large"
                    allowClear
                    showSearch
                    onChange={handleStateChange}
                    value={selectedState || undefined} // Ensures placeholder appears when no value is selected
                    filterOption={(input: any, option: any) =>
                      option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {states.map((state) => (
                      <Select.Option key={state.code} value={state.country}>
                        {state.country}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              <div>
                {/* <label className="  ml-1 ">City        <span className="text-red-500">*</span> </label> */}
                <Form.Item
                  name="city"
                  className="mb-4"

                >
                  <label
                    htmlFor="name"
                    className="absolute -top-4 z-1 left-6 bg-white px-2 text-[18px] text-black"
                  >
                    City  <span className="text-[#F9B138]"><span className="text-[#F9B138]">*</span></span>
                  </label>
                  {/* <Input
                    placeholder="City"
                    size="large"
                    className="Allinput"
                    disabled={pinloading}
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  /> */}
                  <Select
                    placeholder="Select City"
                    size="large"
                    allowClear
                    showSearch
                    onChange={(value) => { setSelectedCity(value); setCity(value) }}
                    value={selectedCity || undefined} // Ensures placeholder appears when no value is selected
                    filterOption={(input: any, option: any) =>
                      option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {cities?.map((city: any) => (
                      <Select.Option key={city.code} value={city.name}>
                        {city.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            </Col>

          </Row>
        </>
      ),
    },
    {
      title: "Contact Information",
      imgSrc: img2,
      content: (
        <>
          <div>
            <Row>
              <Col span={4} className="pt-4">
                <hr className="border-t-4 border-black border-2 h-2 mx-auto" />
              </Col>
              <Col span={20} className="pt-2 pl-2 text-[20px] font-semibold">
                Contact Details
              </Col>
              <Col span={24} className="pr-3">
                {/* <label className="p-2 text-base mb-1 mt-4">
                  Contact Person
                  <span className="text-red-500">*</span>
                </label> */}
                <Row gutter={16} className="mt-4">
                  {/* Title Dropdown */}
                  {/* <Col xs={7} sm={4} md={3} lg={4} xl={4} xxl={3}>
                    <Form.Item>
                      <Select
                        placeholder="Mr"
                        style={{
                          width: "100%",
                          borderRadius: "4px",
                          height: "50px",
                          border: "1px  #d9d9d9", // Add border here
                          // paddingLeft: "10px" // Optional padding for better alignment
                        }}
                      >
                        <Select.Option value="Mr">Mr</Select.Option>
                        <Select.Option value="Ms">Ms</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col> */}

                  {/* Contact Person Name Input */}
                  <Col xs={24} sm={18} md={18} lg={24} xl={24} xxl={24}>
                    <Form.Item
                      name="contactPersonName"
                      className="mb-4"
                    >
                      <label
                        htmlFor="name"
                        className="absolute -top-4 z-50 left-6 bg-white px-2 text-[18px] xs:px-1 xs:text-[16px] text-black"
                      >
                        Name  <span className="text-[#F9B138]"><span className="text-[#F9B138]">*</span></span>
                      </label>
                      {/* <Input
                        size="large"
                        className="Allinput border-none focus:ring-0 outline-none"
                        value={`${contactPersonName}`} // Combines Select and Name
                        onChange={(e) =>
                          setContactPersonName(e.target.value)
                        }
                        bordered={false}
                        style={{
                          width: "100%",
                          background: "transparent",
                          padding: "8px 12px",
                          fontSize: "16px",
                          borderBottom: "1px solid #d9d9d9", // Optional bottom border
                        }}
                        prefix={
                          <Select
                            defaultValue={"Mr"}
                            style={{
                              width: 60,
                              background: "transparent",
                              marginRight: 8,
                            }}
                            bordered={false}
                          >
                            <Select.Option value="Mr">Mr</Select.Option>
                            <Select.Option value="Ms">Ms</Select.Option>
                          </Select>
                        }
                      /> */}
                      <Space.Compact className="border-1 border-[#d9d9d9] !rounded-[8px]" style={{ width: "100%", height: "47px" }}>
                                              <Select
                                                defaultValue={"Mr"}
                                                size="large"
                                                className="remove-border-field"
                                                options={[
                                                  { value: "Mr", label: "Mr" },
                                                  { value: "Ms", label: "Ms" },
                                          ]}
                                          style={{ width: 80,
                                            display: "flex",
                                            alignItems: "center", }}
                                        />
                                        <Input
                                          placeholder="Enter Contact Person Name"
                                          size="large"
                                          className="Allinput !rounded-tl-none !rounded-bl-none remove-border-field"
                                          value={contactPersonName}
                                          onChange={(e) => setContactPersonName(e.target.value)}
                                          bordered
                                          style={{
                                            flex: 1,
                                            height: "50px",
                                            lineHeight: "50px",
                                            background: "transparent",
                                            padding: "8px 12px",
                                            fontSize: "16px",
                                            borderBottom: "1px solid #d9d9d9", // Optional underline effect
                                          }}
                                        />
                                      </Space.Compact>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col span={24} className="pr-3">
                <Row gutter={16} className="align-items-baseline">
                  <Col xs={24} sm={18} md={18} lg={24} xl={24} xxl={24}>
                    <Form.Item
                      name="mobileNumber"
                      className="mb-4"
                    // rules={
                    //   isRapidexieLogin
                    //     ? [] // No validation rules if logged in via Rapidexie
                    //     : [
                    //         {
                    //           required: true,
                    //           message: "Please input Mobile Number",
                    //         },
                    //         {
                    //           pattern: new RegExp(/^\d{10}$/),
                    //           message: "Please enter a valid 10-digit Mobile Number",
                    //         },
                    //       ]
                    // }
                    >
                      <label
                        htmlFor="name"
                        className="absolute -top-4 z-1 left-6 bg-white px-2 xs:px-1 xs:text-[16px]  text-black"
                      >
                        Mobile Number<span className="text-[#F9B138]"><span className="text-[#F9B138]">*</span></span>
                      </label>
                      <PhoneInput
                        country={countryCode}
                        value={mobileNumber}
                        onChange={handlePhoneChange}
                        enableSearch={true}
                        inputProps={{
                          required: true,
                          name: "mobile",
                          autoFocus: true,
                        }}
                        inputStyle={{
                          width: "100%",
                          height: "48px",
                          paddingLeft: "48px",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                        }}
                      />
                    </Form.Item>

                  </Col>
                </Row>

                <Row gutter={16} className="align-items-baseline">
                  {/* <Col xs={7} sm={4} md={3} lg={3} xl={4} xxl={3}>
                    <Input defaultValue="+91" className="Allinput" readOnly />
                  </Col> */}
                  <Col xs={24} sm={18} md={18} lg={24} xl={24} xxl={24}>
                    <Form.Item
                      name="whatsappNumber"
                      className="mb-4"
                    // rules={
                    //   isRapidexieLogin
                    //     ? [] // No validation rules if logged in via Rapidexie
                    //     : [
                    //         {
                    //           required: true,
                    //           message: "Please input WhatsApp Number",
                    //         },
                    //         {
                    //           pattern: new RegExp(/^\d{10}$/),
                    //           message: "Please enter a valid 10-digit WhatsApp Number",
                    //         },
                    //       ]
                    // }
                    >
                      <label
                        htmlFor="name"
                        className="absolute -top-4 z-1 left-5 bg-white px-2 text-[18px] xs:px-1 xs:text-[16px]  text-black"
                      >
                        WhatsApp Number  <span className="text-[#F9B138]"><span className="text-[#F9B138]">*</span></span>
                      </label>
                      <PhoneInput
                        country={countryCode}
                        value={whatsappNumber}
                        // onChange={(value) => handlePhoneChange(value, country, "whatsapp")}
                        onChange={handleWhatsappChange}
                        enableSearch={true}
                        inputProps={{
                          required: true,
                          name: "mobile",
                          autoFocus: true,
                        }}
                        inputStyle={{
                          width: "100%",
                          height: "48px",
                          paddingLeft: "48px",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>


                <Row gutter={16} className="align-items-baseline">
                  {/* <Col xs={7} sm={4} md={3} lg={3} xl={4} xxl={3}>
                    <Input defaultValue="+91" className="Allinput" readOnly />
                  </Col> */}
                  <Col xs={24} sm={18} md={18} lg={24} xl={24} xxl={24}>
                    <Form.Item
                      name="landlineNumber"
                      className="mb-4"
                    >
                      <label
                        htmlFor="name"
                        className="absolute -top-4 z-1 left-5 bg-white px-2 text-[18px] text-black"
                      >
                        Landline Number
                      </label>
                      <PhoneInput
                        country={countryCode}
                        value={landlineNumber}
                        onChange={handleLandlineChange}
                        enableSearch={true}
                        inputProps={{
                          required: true,
                          name: "mobile",
                          autoFocus: true,
                        }}
                        isValid={() => true}
                        inputStyle={{
                          width: "100%",
                          height: "48px",
                          paddingLeft: "48px",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>

              <Col span={4} className="pt-4">
                <hr className="border-t-4 mr-5 border-black border-2 h-2 mx-auto" />
              </Col>
              <Col span={20} className="pt-2 pl-3 text-[20px] font-semibold">
                Email
              </Col>
              <Col xs={24} sm={18} md={19} lg={24} xl={24} xxl={24} className="pr-3">
                <Col xs={24} sm={18} md={18} lg={24} xl={24} xxl={24}>
                  <p className="text-base p-2">Email</p>
                </Col>
                <Form.Item
                  name="email"
                  className="mb-4"

                >
                  <Input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email" className="Allinput" />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </>
      ),
    },
    {
      title: "Business Hours",
      imgSrc: img3,
      content: (
        <>
          <Form.Item label="Select Opening Day & Time" name="days">
            <Row>
              <Col span={4} className="pt-4">
                <hr className="border-t-4 border-black border-2 h-2 mx-auto" />
              </Col>
              <Col span={20} className="pt-2 pl-2 text-[20px] font-semibold">
                Opening Days & Timings
              </Col>

              <Col span={24}>
                <div className="mt-4">
                  <div className="flex space-x-2 timings-row">
                    {days.map((day, index) => (
                      <Button
                        key={day.name}
                        className={day.selected ? 'selected-day' : 'timiingSlotcheckbox'}
                        onClick={() => handleDayChange(index, 'selected', !day.selected)}
                      >
                        {day.name}
                      </Button>
                    ))}
                  </div>

                  <div className="mt-2">
                    <Checkbox checked={selectAll} onChange={handleSelectAll}>
                      Select All Days
                    </Checkbox>
                  </div>

                  <div className="mt-4">
                    <Row gutter={16}>
                      <Col xs={24} md={12}>
                        <label className="block">Open at</label>
                        <Form.Item
                          name="openTime"
                          rules={[
                            {
                              required: true,
                              message: "Please select opening time",
                            },
                          ]}
                        >
                          <Select
                            size="large"
                            className="mt-1 block w-full"
                            value={days.find((day) => day.selected)?.openTime || undefined}
                            onChange={(value) => {
                              setDays(
                                days.map((day) =>
                                  day.selected ? { ...day, openTime: value } : day
                                )
                              );
                            }}

                          >
                            <Option value="">Select</Option>
                            {times.map((time) => (
                              <Option key={time} value={time}>
                                {time}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={12}>
                        <label className="block">Close at</label>
                        <Form.Item
                          name="closeTime"
                          rules={[
                            {
                              required: true,
                              message: "Please select closing time",
                            },
                          ]}
                        >
                          <Select
                            size="large"
                            className="mt-1 block w-full"
                            value={days.find((day) => day.selected)?.closeTime || undefined}
                            onChange={(value) => {
                              setDays(
                                days.map((day) =>
                                  day.selected ? { ...day, closeTime: value } : day
                                )
                              );
                            }}
                          >
                            <Option value="">Select</Option>
                            {times.map((time) => (
                              <Option key={time} value={time}>
                                {time}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </Form.Item>

        </>
      ),
    },
    {
      title: "Gallery",
      imgSrc: img4,
      content: (
        <>
          <Row>
            <Col span={4} className="pt-4">
              <hr className="border-t-4 border-black border-2 h-2 mx-auto" />
            </Col>
            <Col span={20} className="pt-2 pl-2 text-[20px] font-semibold">
              Gallery Images
            </Col>
            <Col span={24}>

              <label className="  mt-4 ml-1 mb-1">
                Gallery Images
              </label>
              <Form.Item name="galleryImage"

                rules={[{
                  required: !galleryFileList.length || !galleryFileList.some((file: any) => file.type.startsWith("image/")),  // Only required if no files are uploaded or any file has no URL
                  message: "Please select a file"
                }]}
              >
                <Dragger {...galleryImageProps} accept="image/*"
                  className="h-48">
                  <p className="ant-upload-drag-icon d-flex justify-center">
                    <BiSolidInbox />
                  </p>
                  <p className="ant-upload-text">
                    Click or drag file to this area to upload
                  </p>
                  <p className="ant-upload-hint">

                  </p>
                </Dragger>
              </Form.Item>
              <div className="gallery-preview">
                <div className="grid grid-cols-2 gap-4">
                  {galleryPreviewImages.map((image, index) => (
                    <div key={index} className="relative">
                      <img
                        src={image}
                        alt={`Gallery ${index}`}
                        className="w-full h-auto"
                      />
                      <button
                        className="absolute top-0 right-0 bg-yellow-700 text-black p-1"
                        onClick={() => handleRemoveGalleryImage(index)}
                      >
                        <CloseOutlined />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </>
      ),
    },
  ];

  return (
    <>

      {/* <div className="form-container mt-20 px-4 py-10 w-3/4 mx-auto rounded-xl shadow-lg">
        <div className="form-header flex justify-between items-center">
          <h2 className="text-2xl ">Add Listing</h2>
          <Link to="/" className="text-yellow ">Back</Link>
        </div>
        <hr className="my-4" /> */}

      <Form
        form={form}
        className="mt-12"
        layout="vertical"
      >
        <Row className="form-container px-4 py-5 xl:w-3/4  mx-auto rounded-xl ">
          {/* <Progress  percent={profileStrength} /> */}
          <Col span={24}>
            {/* <Steps current={current}>
            {steps.map((step, index) => (
              <Step key={index} title={step.title} />
            ))}
          </Steps> */}
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12} className="hidden md:block" >
            <img
              src={steps[current].imgSrc}
              className="w-full h-[100%]"
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
            <div className="steps-content ">
              {steps[current].content}
              <div className="steps-action flex justify-end pt-2">
                {current > 0 && (
                  <button
                    className="rounded-md text-black p-2 mr-1 primary w-full font-semibold bg-[#F9B138]"
                    onClick={() => prev()}
                  >
                    Previous
                  </button>
                )}
                {current < steps.length - 1 && (
                  <button
                    className="rounded-md text-black p-2 primary w-full font-semibold bg-[#F9B138]"
                    onClick={() => next()}
                  >
                    Save & Continue
                  </button>
                )}
                {current === steps.length - 1 && (
                  <button
                    className="rounded-md text-black p-2 primary w-full font-semibold bg-[#F9B138]"
                    type="submit"
                    onClick={onFinishForm}
                    disabled={loading || galleryFileList.some((file: any) => file.size / 1024 / 1024 >= 10)} >
                    {loading ? (
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Spin size="small" /> {/* Spinner */}
                        <span style={{ marginLeft: '8px' }}>Submitting...</span> {/* Text */}
                      </div>
                    ) : (
                      'Submit'
                    )}
                  </button>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Form>
      {/* </div> */}
    </>
  );
};

export default AddListing;